<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>预约审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form label-width="100px" :model="listParams">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="审核状态：" prop="status">
              <el-select size="small" v-model="listParams.status" style="width: 100%; float: left" clearable>
                <el-option value="1" label="待反馈"></el-option>
                <el-option value="6" label="待确认"></el-option>
                <el-option value="3" label="预订成功"></el-option>
                <el-option value="2" label="无法接待"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label=" 所属片区：" prop="region">
              <el-select size="small" v-model="listParams.region" style="float: left; width: 100%">
                <el-option value="1" label="对内"> </el-option>
                <el-option value="2" label="对外"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="宾馆名称：" prop="hotelId">
              <el-select size="small" v-model="listParams.hotelId" style="float: left; width: 100%">
                <el-option v-for="item in hotels" :label="item.name" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="预留手机号：" prop="tel">
              <el-input v-model="listParams.tel" size="small" placeholder="输入手机号" style="float: left; width: 100%"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="预定时间：" prop="time">
              <el-date-picker
                size="small"
                v-model="tempDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 100%"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label=" ">
              <el-button size="small" type="primary" @click="searchData" style="margin-top: 4px"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="" align="center" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.statusValue == 6" style="color: #4391f7">{{ scope.row.statusDisplay }}</span>
            <span v-if="scope.row.statusValue == 3" style="color: rgba(0, 150, 136, 1)">{{ scope.row.statusDisplay }}</span>
            <span v-if="scope.row.statusValue == 2" style="color: rgba(255, 152, 0, 1)">{{ scope.row.statusDisplay }}</span>
            <span v-if="scope.row.statusValue == 1" style="color: rgba(16, 16, 16, 0.38)">{{ scope.row.statusDisplay }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="region" align="center" label="宾馆分类"> </el-table-column>

        <el-table-column prop="hotelName" align="center" label="宾馆名称"> </el-table-column>

        <el-table-column prop="" align="center" label="入住时间">
          <template slot-scope="scope">
            <span v-if="scope.row.statusValue == 6">{{ scope.row.adjustCheckInTime }}</span>
            <span v-if="scope.row.statusValue != 6">{{ scope.row.checkInTime }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" label="离店时间">
          <template slot-scope="scope">
            <span v-if="scope.row.statusValue == 6">{{ scope.row.adjustCheckOutTime }}</span>
            <span v-if="scope.row.statusValue != 6">{{ scope.row.checkOutTime }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="tel" align="center" label="预留手机号"> </el-table-column>

        <el-table-column prop="hotelRoomName" align="center" label="预留房型"> </el-table-column>

        <el-table-column prop="roomNumber" align="center" label="订房数量"> </el-table-column>

        <el-table-column prop="" align="center" label="金额约(¥)">
          <template slot-scope="scope">
            <span v-if="scope.row.statusValue == 6">{{ scope.row.adjustPrice }}</span>
            <span v-if="scope.row.statusValue != 6">{{ scope.row.price }}</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog title="审核操作" :visible.sync="dialogFormVisible" style="text-align: center">
      <el-form style="width: 200px; margin: auto" :model="form">
        <el-form-item>
          <el-select v-model="form.status" placeholder="请选择">
            <el-option label="通过" value="3"></el-option>
            <el-option label="拒绝" value="2"></el-option>
            <el-option label="待审核" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="margin: auto; margin-top: 50px">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hotels: [],
      listParams: {
        status: "",
        region: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogFormVisible: false,
      form: {},
      bodyParams: {
        hotelId: "",
        status: "",
        checkInTime: "",
        checkOutTime: "",
        tel: "",
        page: 1,
        size: 15,
      },
      tempDate: "",
      orderId: 0,
    };
  },
  mounted() {
    this.getHotels();
    this.loadTableData();
  },
  methods: {
    showCheck(id) {
      this.dialogFormVisible = true;
      this.orderId = id;
    },
    check() {
      const bodyParams = Object.assign({}, this.listParams, {
        orderId: this.orderId,
        status: this.form.status,
      });
      console.info("status-check: " + this.form.status);
      this.$http({
        url: global.apiUrl + "/reception/order/check",
        method: "POST",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.$message.success(res.body.info);
              this.dialogFormVisible = false;
              this.loadTableData();
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    getHotels() {
      this.$http({
        url: global.apiUrl + "/reception/hotel/list",
        method: "GET",
        params: {
          page: 1,
          size: 10000,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data && res.body.data.data.length > 0) {
              this.hotels = res.body.data.data;
            } else {
              this.hotels = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/reception/order/list/superAdmin",
        method: "GET",
        params: this.bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.data.length > 0) {
              this.tableData = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    searchData: function () {
      this.tableLoading = true;
      let checkInTime, checkOutTime, status, region;

      try {
        checkInTime = this.tempDate[0];
        checkOutTime = this.tempDate[1];
      } catch (e) {
        checkInTime = "";
        checkOutTime = "";
      }

      if (this.listParams.status != "") {
        status = parseInt(this.listParams.status);
      } else {
        status = undefined;
      }
      if (this.listParams.region != "") {
        region = parseInt(this.listParams.region);
      } else {
        region = undefined;
      }

      this.bodyParams = Object.assign({}, this.listParams, {
        status: status,
        hotelId: this.listParams.hotelId,
        region: this.listParams.region,
        checkInTime: checkInTime,
        checkOutTime: checkOutTime,
        tel: this.listParams.tel,
        page: this.pager.pageIndex,
        size: this.pager.pageSize,
      });

      this.$http({
        url: global.apiUrl + "/reception/order/list/superAdmin",
        method: "GET",
        params: this.bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.data.length > 0) {
              this.tableData = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>
<style>
#convalescenceInfoTable {
  width: 100%;
}
#convalescenceInfoTable th {
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}
#convalescenceInfoTable td {
  font-size: 14px;
}
</style>
